const env = {
  API: process.env.REACT_APP_API_URL,
  IMAGE_API: process.env.REACT_APP_IMAGE_API_URL,
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  LINKEDIN_CLIENT_ID: process.env.REACT_APP_LINKEDIN_CLIENT_ID,
  LINKEDIN_REDIRECT_URL: process.env.REACT_APP_LINKEDIN_REDIRECT_URL,
  LINKEDIN_OAUTH_URL: process.env.REACT_APP_OAUTH_URL,
  LINKEDIN_SCOPE: process.env.REACT_APP_LINKEDIN_SCOPE,
  LINKEDIN_STATE: process.env.REACT_APP_LINKEDIN_STATE,
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",
  REACT_APP_STRIPE_PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY || "",
  REACT_APP_APP_ENV: process.env.REACT_APP_APP_ENV,
  REACT_APP_PIXEL_ID: process.env.REACT_APP_PIXEL_ID,
  REACT_APP_META_ACCESS_TOKEN: process.env.REACT_APP_META_ACCESS_TOKEN,
  HUBSPOT_PORTALID: process.env.REACT_APP_HUBSPOT_PORTALID,
  HUBSPOT_FORMGUID: process.env.REACT_APP_HUBSPOT_FORMGUID,
  HUBSPOT_FORMGUID_NOTIFYME: process.env.REACT_APP_HUBSPOT_FORMGUID_NOTIFYME,
  REACT_APP_URL: process.env.REACT_APP_URL,
  STRIPE_REDIRECT_URL: process.env.REACT_APP_STRIPE_REDIRECT_URL,
  MAILCHIMP_API_ENDPOINT: process.env.REACT_APP_MAILCHIMP_API_ENDPOINT,
  MAILCHIMP_API_KEY: process.env.REACT_APP_MAILCHIMP_API_KEY,
  MAILCHIMP_LIST_ID: process.env.REACT_APP_MAILCHIMP_LIST_ID,
  MAILCHIMP_NOTIFY_ME_LIST_ID: process.env.REACT_APP_MAILCHIMP_NOTIFY_ME_LIST_ID,
};
export default env;
